"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit"),
    _OptionsMenu = _interopRequireDefault(require("./OptionsMenu")),
    _captions = require("../../Addons/constants/captions"),
    _DownloadAssetMenu = require("../../DownloadAssetMenu");

function getVolumeIcon(a) {
  return 0 === a ? "speakermute" : .4 > a ? "speakermin" : .7 > a ? "speakermax" : "speaker";
}

function parseSeconds(a) {
  var b = "".concat(Math.floor(a / 60)),
      c = (a % 60).toFixed(2),
      d = c.split(".");
  return "".concat(b, ":").concat(d[0].padStart(2, "0"));
}

function getResolutionOption(a, b) {
  return {
    label: a.label,
    onClick: b(a),
    superscript: !!a.isLevelHD && "HD"
  };
}

function getCaptionOption(a, b) {
  var c = JSON.parse(a.metaData),
      d = c.lang;
  return {
    label: _captions.LANGUAGES[d.toUpperCase()],
    onClick: b(a)
  };
}

function Controls(a) {
  var b = a.currentTime,
      c = a.toggleVideoPlay,
      d = a.toggleFullscreen,
      e = a.toggleHD,
      f = a.toggleVolume,
      g = a.toggleComments,
      h = a.onSelectResolution,
      i = a.isPlaying,
      j = a.volume,
      k = a.isCommentsEnabled,
      l = a.showComments,
      m = a.isHD,
      n = a.isFullscreen,
      o = a.isVideoStream,
      p = a.isVideoFile,
      q = a.isStreamHighDef,
      r = a.selectedResolution,
      s = a.resolutions,
      t = a.captions,
      u = a.selectedCaption,
      v = a.asset,
      w = a.loading,
      x = a.onSelectCaption,
      y = t || [],
      z = (0, _react.useState)(!0),
      A = (0, _slicedToArray2["default"])(z, 2),
      B = A[0],
      C = A[1],
      D = "white75",
      E = "white";
  return _react["default"].createElement("div", {
    className: "player__control-bar"
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])("player__control-bar__controls", {
      "player__control-bar__controls--loading": w
    })
  }, _react["default"].createElement("div", {
    className: "player__control-bar__controls__section"
  }, _react["default"].createElement(_uiKit.Icon, {
    className: (0, _classnames["default"])({
      "player__control-bar__play-icon": B
    }),
    onClick: !w && c,
    name: i ? "pause" : "play",
    color: D,
    hoverColor: E,
    size: 20
  }), _react["default"].createElement(_uiKit.Icon, {
    className: (0, _classnames["default"])({
      "player__control-bar__skip-icon": B
    }),
    name: "skip",
    color: D,
    hoverColor: E,
    size: 25
  }), _react["default"].createElement(_uiKit.Icon, {
    className: "player__control-bar__volume-icon",
    onClick: !w && f,
    name: getVolumeIcon(j),
    color: D,
    hoverColor: E,
    size: 25,
    disabled: w
  }), _react["default"].createElement("p", {
    className: "player__control-bar__controls__time"
  }, parseSeconds(b))), _react["default"].createElement("div", {
    className: "player__control-bar__controls__section"
  }, o ? _react["default"].createElement(_OptionsMenu["default"], {
    options: s.map(function (a) {
      return getResolutionOption(a, h);
    }),
    selectedIndex: s.findIndex(function (a) {
      return a === r;
    }),
    setIconLabelsVisibility: C,
    disabled: w
  }, _react["default"].createElement(_uiKit.Icon, {
    className: (0, _classnames["default"])("player__control-bar__quality-icon-paths", {
      "player__control-bar__quality-icon": B
    }, {
      "player__control-bar__quality-icon--streaming-hd": q
    }),
    name: "vidres",
    size: 20
  })) : null, _react["default"].createElement(_DownloadAssetMenu.DownloadAssetMenu, {
    asset: v,
    disabled: w
  }, _react["default"].createElement(_uiKit.Icon, {
    className: (0, _classnames["default"])("player__control-bar__download", {
      "player__control-bar__download-icon": B
    }),
    name: "download",
    size: 19,
    color: D,
    hoverColor: E
  })), l ? _react["default"].createElement(_uiKit.Icon, {
    className: (0, _classnames["default"])({
      "player__control-bar__comments-icon": B
    }),
    onClick: !w && g,
    name: "comments",
    color: k && !w ? "white" : D,
    hoverColor: k && !w ? "white75" : E,
    size: 25
  }) : null, _react["default"].createElement(_OptionsMenu["default"], {
    options: y.map(function (a) {
      return getCaptionOption(a, x);
    }),
    selectedIndex: y.findIndex(function (a) {
      return a === u;
    }),
    setIconLabelsVisibility: C,
    disabled: w
  }, _react["default"].createElement(_uiKit.Icon, {
    className: (0, _classnames["default"])({
      "player__control-bar__captions-icon": B
    }),
    name: "captions",
    color: u ? "white" : D,
    hoverColor: y.length ? E : void 0,
    size: 25
  })), p ? _react["default"].createElement(_uiKit.Icon, {
    className: (0, _classnames["default"])({
      "player__control-bar__def-icon": B
    }),
    onClick: !w && e,
    name: "hd",
    color: m ? "white" : D,
    hoverColor: m ? "white75" : E,
    size: 25
  }) : null, _react["default"].createElement(_uiKit.Icon, {
    className: (0, _classnames["default"])({
      "player__control-bar__fullscreen-icon": B
    }),
    onClick: !w && d,
    name: n ? "defscreen" : "fullscreen",
    color: D,
    hoverColor: E,
    size: 20
  }))));
}

var _default = (0, _react.memo)(Controls);

exports["default"] = _default;